<div class="source-div questionGaps" [formGroup]="parent">
    <ng-container class="label-text">
        <legend class="removeBorder">
        <span [id]="domId" *ngIf="question.questionText" class="text-left tall-weigh-question-text">{{question.questionText}}</span>
        </legend>
        <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)" *ngIf="question.helpText" class=" col-sm-1 tall-info" [childId]="question.id" [tooltipData]="tooltipObj" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()"></app-tool-tip-notification>
    </ng-container>
    <div class="newPos" role="radiogroup">
        <label class="switch">

            <input type="checkbox" class="switch-input" tabindex="-1">
            <span class="access" tabindex="-1">choose measuring system</span>
            <span [ngClass]="focusOnLblOne " class="adjustFocusToLeft reflect" aria-hidden="true" tabindex="-1"></span>
            <span [ngClass]="focusOnLblTwo " class="adjustFocusToRight reflect" aria-hidden="true" tabindex="-1"></span>
            <span class="switch-toggle toggleLeft reflect" [ngClass]="switchLblOne" [attr.aria-label]="label1test" tabindex="0"
                id="{{domId}}{{label1test}}" role="radio" (keyup.enter)="emitToggleOptions(this.label1test)" (click)="emitToggleOptions(this.label1test)">{{label1test}}</span>
            <!--label1 -->
            <span class="switch-toggle toggleRight reflect" [ngClass]="switchLblTwo" [attr.aria-label]="label2test" tabindex="0"
                id="{{domId}}{{label2test}}" role="radio" (keyup.enter)="emitToggleOptions(this.label2test)" (click)="emitToggleOptions(this.label2test)">{{label2test}}</span>
            <!--label2-->
        </label>
    </div>
</div>
<div *ngIf="parent && parent.errors" class="col-md-12 form-validation-error">
    <i class="icon icon-error" aria-hidden="true "></i>
    <p *ngIf="parent.errors.required ">Please make a selection</p>
</div>